/* eslint-disable */
/**
 * The path of the `DeliveriesPage` to be consumed by a `<Router />`
 * @export
 */
export const DELIVERIES_PAGE_PATH = `/deliveries`;

/**
 * Create a `href` that will resolve to `DeliveriesPage`
 * @export
 * @returns {string} The `DELIVERIES_PAGE_PATH`
 */
export const createDeliveriesPageLink = () => DELIVERIES_PAGE_PATH;

/**
 * Determine if the current page is the `DeliveriesPage`
 * @export
 * @param {RouterMatch<any>} match The `react-router-dom`'s `match` params
 * @returns {boolean} Whether or not the current page is `DeliveriesPage`
 */
export const isDeliveriesPage = (match) => match.path === DELIVERIES_PAGE_PATH;
